export default {
    graphql: {
        resourceBody: `
            identity_role_plain_list_identity_id(limit:20, order:"+id"){
                id
                propagate
                role_id_role{
                    id
                    name
                }
            }
        `,
    },
};
